import {
	DOWNLOAD_PERMISSIONS,
	UPLOAD_PERMISSIONS,
	APPEND_PERMISSIONS,
	BENCHMARK_PERMISSIONS,
	APVENDORDB_PERMISSIONS,
	APPEND_UPLOAD_PERMISSIONS,
	PUSH_TO_DB_PERMISSIONS,
	PERMISSIONS,
} from 'contexts/PermissionsContext';

export const ROOT_ROUTE = '/data';

export const CONFIG = [
	{
		name: 'vendorCleanup',
		label: 'Vendor Normalization',
		requiredSome: UPLOAD_PERMISSIONS,
		child: [
			{
				path: `${ROOT_ROUTE}/vendor-cleanup`,
				name: 'vendorCleanup',
				label: 'Vendor Normalization',
				requiredSome: UPLOAD_PERMISSIONS,
			},
			{
				path: `${ROOT_ROUTE}/vendor-edit`,
				name: 'vendorEdit',
				label: 'Normalized Vendors ',
				requiredSome: UPLOAD_PERMISSIONS,
			},
			{
				path: `${ROOT_ROUTE}/vendor-mapping`,
				name: 'vendorMapping',
				label: 'Vendor Mapping',
				requiredSome: UPLOAD_PERMISSIONS,
			},
		],
	},
	{
		name: 'append',
		label: 'Append/Overwrite',
		requiredSome: APPEND_UPLOAD_PERMISSIONS,
		child: [
			{
				path: `${ROOT_ROUTE}/append`,
				name: 'append',
				label: 'Append New Data',
				requiredSome: APPEND_PERMISSIONS,
			},
			{
				path: `${ROOT_ROUTE}/upload`,
				name: 'upload',
				label: 'Overwrite Spend Cube',
				requiredSome: UPLOAD_PERMISSIONS,
			},
		],
	},
	{
		name: 'download',
		label: 'Download Data',
		path: `${ROOT_ROUTE}/download`, // include path key when you don't want to group navigation
		requiredSome: DOWNLOAD_PERMISSIONS,
		child: [
			{
				path: `${ROOT_ROUTE}/download`,
				name: 'download',
				label: 'Download Data',
				requiredSome: DOWNLOAD_PERMISSIONS,
			},
		], // add child to Route it
	},
	{
		name: 'pushtoDB',
		label: 'Push to DB',
		requiredSome: PUSH_TO_DB_PERMISSIONS,
		child: [
			{
				path: `${ROOT_ROUTE}/pushtobenchmark`,
				name: 'pushBenchmark',
				label: 'Push to Benchmark',
				requiredSome: BENCHMARK_PERMISSIONS,
			},
			{
				path: `${ROOT_ROUTE}/push-to-apvendordb`,
				name: 'pushToApVendorDB',
				label: 'Push to ApVendorDB',
				requiredSome: APVENDORDB_PERMISSIONS,
			},
			{
				path: `${ROOT_ROUTE}/update-apvendordb`,
				name: 'updateApVendorDB',
				label: 'Update ApVendorDB',
				requiredSome: APVENDORDB_PERMISSIONS,
			},
		],
	},
	{
		name: 'form',
		label: 'Survey Form',
		path: `${ROOT_ROUTE}/form`, // include path key when you don't want to group navigation
		requiredSome: [PERMISSIONS.SurveyFormRead],
		child: [
			{
				path: `${ROOT_ROUTE}/form`,
				name: 'form',
				label: 'Survey Form',
				requiredSome: [PERMISSIONS.SurveyFormRead],
			},
		], // add child to Route it
	},
];
